// extracted by mini-css-extract-plugin
module.exports = {"painterOptionSelector":"PainterOptionSelector_painterOptionSelector__2Q960","radio":"PainterOptionSelector_radio__1hkSf","label":"PainterOptionSelector_label__ZkUzT"};